import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  Link
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { protectedResources } from "../../authConfig";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import {useTranslation} from "react-i18next";
import customizerSlice, { getuserName } from "../../store/customizer/CustomizerSlice";

const PrivacyPolicyModal = ({ open, onClose, onDecline, userId }) => {
  const [accepted, setAccepted] = useState(false);
  const dispatch = useDispatch();
  const customizer = useSelector((state) => state.customizer);
  const { t } = useTranslation();
  const { error: fetchError, execute, isLoading } = useFetchWithMsal({
    scopes: protectedResources.apiUserTerms.scopes.write,
  });


  const handleAccept = () => {
    execute("PUT", protectedResources.apiUserTerms.endpoint.replace('{userId}', userId)).then((response) => {
      if (response.Status === 200) {
        dispatch(getuserName({
          ...customizer.userName,
          TermsAndPrivacyAccepted: true
        }));
      }
      onClose();

    });
  };

  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <DialogTitle>{t('Privacy_policy_title')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('Privacy_policy_body1')}
        </Typography>
        <Typography sx={{marginBottom: '2rem'}}>
          {t('Privacy_policy_body2')}
     
            <Link
              href="https://www.hicmobile.com/privacyhicmobile"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.hicmobile.com/privacyhicmobile/
            </Link>
        </Typography>
       
      </DialogContent>
      <DialogActions>
        <Button onClick={onDecline} color="error">
          {t('privacy_refuse')}
        </Button>
        <Button onClick={handleAccept} color="primary" >
          {t('privacy_accept')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrivacyPolicyModal;